import { toRoman } from '@/utils/roman.js';

export function formatMinMax(originalMinMax) {
  if (!originalMinMax) {
    return [];
  }

  const transform = (yearData) =>
    yearData?.bars?.map((item) => ({
      label: item.label,
      bars: item.bars.map((bar) => ({
        value: bar.value,
        label: bar.dateSpan,
      })),
      averageYearlyReturn: item.averageYearlyReturn,
    })) || [];

  return {
    year1: transform(originalMinMax.year1),
    year5: transform(originalMinMax.year5),
    year10: transform(originalMinMax.year10),
  };
}

export function formatLineChart(originalLineChart) {
  if (!originalLineChart) {
    return [];
  }

  const merged = {};

  originalLineChart.charts.forEach((chart) => {
    const romanLabel = toRoman(chart.id);
    chart.values.forEach((val) => {
      // Format: 'YYYY-MM-DD'
      const date = val.dateAt.slice(0, 10);
      if (!merged[date]) merged[date] = { date };
      merged[date][romanLabel] = val.valueAt;
    });
  });

  return Object.values(merged);
}
